export interface Tokens {
  access_token: string;
  id_token: string;
  expires_in: number; // The duration in seconds that the access token is valid for.
  refresh_token: string;
}

export interface CardSummary {
  id: string;
  displayNumber: string;
  expired: boolean;
}

export interface AuthenticatedUser extends BaseUser {
  id: string;
  loyaltyBalance?: number;
  birthday?: string;
  loyaltyCheckbox?: boolean;
  allowEmail?: boolean;
  cards: CardSummary[];
}

export interface Asset {
  name: string;
  description: string;
  image: string;
  validUntil: string;
  key?: string;
  id?: string;
  price?: number;
  selectionRules?: SelectionRule[];
}

export interface SelectionRule {
  text: string;
  logic: string;
  requirements: SelectionRequirement[];
}

export interface SelectionRequirement {
  text: string;
  productSkus: string[];
  requiredQty: number;
  requiredPrice: number;
  itemDiscounted: boolean;
}

export interface AssetInfo {
  assets: Asset[];
  purchaseableAssets: Asset[];
}

export interface Cause {
  code: string;
  message: string;
}

export interface BaseUser {
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
}

export enum AuthMethod {
  EMAIL = "email",
  PHONE = "phone",
  GUEST = "guest",
  GOOGLE = "google",
  APPLE = "apple",
}
